import React from "react";
import { Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SecurityInfoTable = ({
  report,
  nameFilter,
  statusFilter,
  searchQuery,
  onUpdateSecurityInfoList,
}) => {
  const navigate = useNavigate();
  const [securityList, setSecurityList] = React.useState(report.securityInfoList);

  // Sync local state when the parent's report.securityInfoList changes
  React.useEffect(() => {
    setSecurityList(report.securityInfoList);
  }, [report.securityInfoList]);

  // Filter the security list based on the passed filter values.
  const filteredSecurityList = securityList.filter((info) => {
    const matchesName = nameFilter
      ? info.clientName.toLowerCase().includes(nameFilter.toLowerCase())
      : true;
    const matchesStatus = statusFilter ? info.status === statusFilter : true;
    const matchesSearch = searchQuery
      ? info.clientName.toLowerCase().includes(searchQuery.toLowerCase())
      : true;
    return matchesName && matchesStatus && matchesSearch;
  });

  const handleSubmitDocument = (info, e) => {
    e && e.stopPropagation();
    if (!report.applicationId || !report.isin || !report.interestPaymentDate || !info.bpId) {
      return;
    }
    navigate(
      `/tax-exempt-reports/application/${report.applicationId}/${report.isin}/${info.bpId}/${info.reportHash}/${report.interestPaymentDate}`
    );
  };

  return (
    <>
      {filteredSecurityList.length > 0 && (
        <tr>
          <td colSpan="5">
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th>Client's Name</th>
                  <th>BPID</th>
                  <th>e-SIP Reference Number</th>
                  <th className="text-right">Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredSecurityList.map((info, idx) => (
                  <tr key={idx}>
                    <td>{info.clientName}</td>
                    <td>{info.bpId}</td>
                    <td>{info.esipReferenceNumber}</td>
                    <td className="text-right">{info.amount}</td>
                    <td>{info.status}</td>
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={(e) => handleSubmitDocument(info, e)}
                        disabled={
                          !(
                            info.status === "Not Submitted" ||
                            info.status === "For Adjustment" ||
                            info.status === "Rejected"
                          )
                        }
                      >
                        Submit Document
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </td>
        </tr>
      )}
    </>
  );
};

export default SecurityInfoTable;
